import React, { useState, useRef, useEffect, Suspense } from 'react';
import IASideBar from './IASideBar';
import * as mui from '@mui/material';
import ResponsiveContainer from '../../layout/Container';
import SearchAppBar from '../../common/Appbar';
import OutlinedCard from '../../common/MediaCard';
import Separator from '../../layout/Separator';
import ReviewsRoundedIcon from '@mui/icons-material/ReviewsRounded';
import auditService from '../../../services/AuditService';
import { useParams } from 'react-router-dom';
import NormalTextField from '../../common/NormalTextField';
import CellTowerRoundedIcon from '@mui/icons-material/CellTowerRounded';
import GridViewRoundedIcon from '@mui/icons-material/GridViewRounded';
import LibraryBooksRoundedIcon from '@mui/icons-material/LibraryBooksRounded';
import AccountTreeRoundedIcon from '@mui/icons-material/AccountTreeRounded';
import AutoStoriesRoundedIcon from '@mui/icons-material/AutoStoriesRounded';
import DataTable from '../../common/DataGrid';
import Tooltip from '@mui/material/Tooltip';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import LibraryAddRoundedIcon from '@mui/icons-material/LibraryAddRounded';
import StyleRoundedIcon from '@mui/icons-material/StyleRounded';
import BeenhereRoundedIcon from '@mui/icons-material/BeenhereRounded';

import appService from '../../../services/ApplicationService';
import DynamicTabs from '../../common/DynamicTabs';
import LinkIcon from '@mui/icons-material/Link';
import MultipleSelect from '../../common/MultipleSelect';
import Select from 'react-select';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import VerticalTabs from '../../common/VerticalTab';
import Divider from '@mui/material/Divider';
import BookmarksIcon from '@mui/icons-material/Bookmarks';
import AddchartIcon from '@mui/icons-material/Addchart';
import Chip from '@mui/material/Chip';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import { Alert } from 'bootstrap';
import AddLinkIcon from '@mui/icons-material/AddLink';
import StarIcon from '@mui/icons-material/Star';
import ReportIcon from '@mui/icons-material/Report';
import TurnedInIcon from '@mui/icons-material/TurnedIn';
import AddModeratorIcon from '@mui/icons-material/AddModerator';
import BookmarkAddIcon from '@mui/icons-material/BookmarkAdd';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ScaleIcon from '@mui/icons-material/Scale';
import SpeedIcon from '@mui/icons-material/Speed';
import InsightsIcon from '@mui/icons-material/Insights';
import ListSubheader from '@mui/material/ListSubheader';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import RadioButtonCheckedRoundedIcon from '@mui/icons-material/RadioButtonCheckedRounded';
import AssignmentTurnedInRoundedIcon from '@mui/icons-material/AssignmentTurnedInRounded';
import FolderSpecialRoundedIcon from '@mui/icons-material/FolderSpecialRounded';
import AnnouncementRoundedIcon from '@mui/icons-material/AnnouncementRounded';
import InfoIcon from '@mui/icons-material/Info';
import SecurityIcon from '@mui/icons-material/Security';
import AddCircleRounded from '@mui/icons-material/AddCircleRounded';
import DeleteIcon from '@mui/icons-material/Delete';
import companyService from '../../../services/CompanyService';
import GppBadIcon from '@mui/icons-material/GppBad';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import ConsolidatedRiskDialog from './ConsolidatedRiskDialog'; // Import the new dialog component

const RiskMapping = () => {
    const [selectedApp, setSelectedApp] = useState([])
    const [apps, setApps] = useState([])
    const [risks, setRisks] = useState([])
    const [controls, setControls] = useState([])
    const [operatingSystem, setOperatingSystem] = useState([])
    const [database, setDatabase] = useState([])
    const [network, setNetwork] = useState([])
    const [mappedRisk, setMappedRisk] = useState([])
    const [bp_mapping, setBPMapping] = useState([])
    const [bp_risk_list, setBPRiskList] = useState([])
    const [it_risk_list, setITRiskList] = useState([])
    const [operational_risk_list, setOperationalRiskList] = useState([])
    const [entity_risk_list, setEntityRiskList] = useState([])
    const [it_mapping, setITMapping] = useState([])
    const [ops_mapping, setOPSMapping] = useState([])
    const [entity_mapping, setEntityMapping] = useState([])
    const [riskRating, setRiskRating] = useState([])
    const [selectedRating, setSelectedRating] = useState([]);
    const [rating, setRating] = useState([]);
    const [ratingRationale, setRatingRationale] = useState(null);
    const [mappedControlsForRisk, setMappedControlsForRisk] = useState({});
    const saveTimeout = useRef(null);

    const [openModal, setOpenModal] = useState(false);
    const [selectedRisk, setSelectedRisk] = useState([])
    const [selectedITRisk, setSelectedITRisk] = useState([])
    const [firstRisk, setFirstRisk] = useState([])
    const [selectedCompany, setSelectedCompany] = useState([])
    const [selectedControls, setSelectedControls] = useState([])
    const [mappedControls, setMappedControls] = useState([])
    const { company_id, id } = useParams();

    const [openBPRiskList, setOpenBPRiskList] = useState(true);
    const [openITRiskList, setOpenITRiskList] = useState(true);
    const [openOperationalRiskList, setOpenOperationalRiskList] = useState(true);
    const [openEntityRiskList, setOpenEntityRiskList] = useState(true);

    //BUSINESS
    const [openBPHR, setOpenBPHR] = useState(true);
    const [openBPMR, setOpenBPMR] = useState(true);
    const [openBPLR, setOpenBPLR] = useState(true);

    const [riskmappingBPHR, setRiskMappingBPHR] = useState([])
    const [riskmappingBPMR, setRiskMappingBPMR] = useState([])
    const [riskmappingBPLR, setRiskMappingBPLR] = useState([])

     //IT
    const [openITHR, setOpenITHR] = useState(true);
    const [openITMR, setOpenITMR] = useState(true);
    const [openITLR, setOpenITLR] = useState(true);

    const [riskmappingITHR, setRiskMappingITHR] = useState([])
    const [riskmappingITMR, setRiskMappingITMR] = useState([])
    const [riskmappingITLR, setRiskMappingITLR] = useState([])

    //OPERATIONAL
    const [openOperationalHR, setOpenOperationalHR] = useState(true);
    const [openOperationalMR, setOpenOperationalMR] = useState(true);
    const [openOperationalLR, setOpenOperationalLR] = useState(true);

    const [riskmappingOperationalHR, setRiskMappingOperationalHR] = useState([])
    const [riskmappingOperationalMR, setRiskMappingOperationalMR] = useState([])
    const [riskmappingOperationalLR, setRiskMappingOperationalLR] = useState([])

    //ENTITY
    const [openEntityHR, setOpenEntityHR] = useState(true);
    const [openEntityMR, setOpenEntityMR] = useState(true);
    const [openEntityLR, setOpenEntityLR] = useState(true);

    const [riskmappingEntityHR, setRiskMappingEntityHR] = useState([])
    const [riskmappingEntityMR, setRiskMappingEntityMR] = useState([])
    const [riskmappingEntityLR, setRiskMappingEntityLR] = useState([])


    const [sidebarVisible, setSidebarVisible] = useState(true);

    const [current_risk, setCurrentRisk] = useState('')

    const [rcmData, setRCMData] = useState([])

    const [openConsolidatedDialog, setOpenConsolidatedDialog] = useState(false);
    const [selectedConsolidatedRisk, setSelectedConsolidatedRisk] = useState(null);

    // Add this state variable with the other state variables at the top of the component
    const [controlCountsMap, setControlCountsMap] = useState({});

    //RISK LIBRARY
    const bp_risk = risks.filter(risk => risk.RISK_TYPE === 'Business Process');
    const it_risk = risks.filter(risk => risk.RISK_TYPE === 'IT');
    const operational_risk = risks.filter(risk => risk.RISK_TYPE === 'Operational');
    const entity_risk = risks.filter(risk => risk.RISK_TYPE === 'Entity Level');

    const [controlMapping, setControlMapping] = useState({})

    // Add a loading state for dialog opening
    const [dialogLoading, setDialogLoading] = useState(false);

    useEffect(() => {
        
        const fetchAppByID = async () => {

            try {

                const appRecord = await appService.fetchAppsById(id)

                if (appRecord) {
                    setSelectedApp(appRecord);

                    const os = await appService.fetchAppsById(appRecord.OS)
                    if (os) {
                        setOperatingSystem(os.APP_NAME)
                    }

                    const db = await appService.fetchAppsById(appRecord.DATABASE)
                    if (db) {
                        setDatabase(db.APP_NAME)
                    }

                    const network = await appService.fetchAppsById(appRecord.NETWORK)
                    if (network) {
                        setNetwork(network.APP_NAME)
                    }

                }

            } catch (fetchError) {
                console.error('Error fetching app record:', fetchError);
                
            }
        }

        const fetchCompany = async () => {
            try {
                const companyRecord = await companyService.fetchCompanyById(company_id)
                setSelectedCompany(companyRecord)

            } catch (fetchError) {
                console.error('Error fetching company record:', fetchError);
            }
        }

       
       
        const fetchRiskLibrary = async () => {
            try {
                const riskRecord = await auditService.fetchRisk()
                if (riskRecord) {
                    setRisks(riskRecord);

                } else {
                    setRisks([]);
                }

            } catch (fetchError) {
                console.error('Error fetching risk record:', fetchError);
                setRisks([])
            }
        }

        const fetchControlsLibrary = async () => {
            let controlsLibrary;
            try {
                controlsLibrary = await auditService.fetchControls()
            } catch (fetchError) {
                console.error('Error fetching controls record:', fetchError);
                setControls([])
            }

            if (controlsLibrary) {
                setControls(controlsLibrary);
            } else {
                setControls([]);
            }
        }

        fetchCompany()
        fetchAppByID()
        fetchRiskLibrary()
        fetchControlsLibrary()
        fetchRiskMapped()
        fetchRiskMapping()

    }, []);

    const fetchRiskMapping = async () => {
        try {
            const riskMapping = await auditService.fetchRiskMappingbyCompany(company_id)
            if (riskMapping) {
               setRCMData(riskMapping)
            }

        } catch (fetchError) {
            console.error('Error fetching rcm record:', fetchError);
        }
    }

    const renderRiskIcon = (riskId) => {
        return (
            <ListItemIcon>
                <RadioButtonCheckedRoundedIcon 
                    style={{ 
                        fontSize: '12px', 
                        color: mappedControlsForRisk[riskId] ? 'green' : 'orange' 
                    }} 
                />
            </ListItemIcon>
        );
    };

      const renderRiskIconAssessment = (riskId) => {
        return (
            <ListItemIcon>
                <RadioButtonCheckedRoundedIcon 
                    style={{ 
                        fontSize: '12px', 
                        color: 'grey' 
                    }} 
                />
            </ListItemIcon>
        );
    };


    const fetchRiskMapped = async () => {
        console.log("Fetching mapped risks...");
        let riskList;
        try {
            riskList = await auditService.fetchRiskMappingbyApp(id, company_id);
            console.log("Raw API response from fetchRiskMappingbyApp:", riskList);
        } catch (fetchError) {
            console.error('Error fetching risk record by app:', fetchError);
            // Reset state on error to prevent stale data
            setMappedRisk([]);
            setRiskMappingBPHR([]);
            setRiskMappingBPMR([]);
            setRiskMappingBPLR([]);
            setRiskMappingITHR([]);
            setRiskMappingITMR([]);
            setRiskMappingITLR([]);
            setRiskMappingOperationalHR([]);
            setRiskMappingOperationalMR([]);
            setRiskMappingOperationalLR([]);
            setRiskMappingEntityHR([]);
            setRiskMappingEntityMR([]);
            setRiskMappingEntityLR([]);
            return;
        }

        if (!riskList) {
            console.warn("No risk list data returned from API");
            return;
        }

        let riskData = riskList.risklist_data;
        console.log("Risk data extracted from API response:", riskData);
        
        if (!Array.isArray(riskData)) {
            console.error("Risk data is not an array:", riskData);
            riskData = [];
        }
        
        // Let's manually check if we need to handle the CONTROL_DETAILS property
        if (Array.isArray(riskData)) {
            // Ensure CONTROL_DETAILS is populated for each risk
            riskData = riskData.map(risk => {
                // If risk doesn't have CONTROL_DETAILS, try to look for it in the controls_data
                if (!risk.CONTROL_DETAILS) {
                    console.log("No CONTROL_DETAILS found for risk ID:", risk.id);
                    
                    // Initialize an empty array for CONTROL_DETAILS if not present
                    risk.CONTROL_DETAILS = [];
                    
                    // If we have controls_data in the response, try to find matching controls
                    if (riskList.controls_data && Array.isArray(riskList.controls_data)) {
                        const matchingControl = riskList.controls_data.find(
                            control => control.RISK_ID === risk.id
                        );
                        
                        if (matchingControl && matchingControl.CONTROL_DETAILS) {
                            risk.CONTROL_DETAILS = matchingControl.CONTROL_DETAILS;
                            console.log("Found CONTROL_DETAILS in controls_data for risk ID:", risk.id);
                        }
                    }
                }
                return risk;
            });
        }

        if (riskData) {
            setMappedRisk(riskData);
            
            // Log the processed data we're setting in state
            console.log("Final mappedRisk data set in state:", riskData);

            const sortedRiskMapping = riskData.sort((a, b) => {
                if (a.RISK_ID < b.RISK_ID) return -1;
                if (a.RISK_ID > b.RISK_ID) return 1;
                return 0;
            });

            const bp_risk_filtered = sortedRiskMapping.filter(risk => risk.RISK_TYPE === 'Business Process');
            const it_risk_filtered = sortedRiskMapping.filter(risk => risk.RISK_TYPE === 'IT');
            const operational_risk_filtered = sortedRiskMapping.filter(risk => risk.RISK_TYPE === 'Operational');
            const entity_risk_filtered = sortedRiskMapping.filter(risk => risk.RISK_TYPE === 'Entity Level');


            //BUSINESS

            const bp_risk_filtered_hr = sortedRiskMapping.filter(risk =>
                risk.RISK_TYPE === 'Business Process' && risk.RATING === 'High'
            );
            setRiskMappingBPHR(bp_risk_filtered_hr);    

            const bp_risk_filtered_mr = sortedRiskMapping.filter(risk =>
                risk.RISK_TYPE === 'Business Process' && risk.RATING === 'Medium'
            );
            setRiskMappingBPMR(bp_risk_filtered_mr);

            const bp_risk_filtered_lr = sortedRiskMapping.filter(risk =>
                risk.RISK_TYPE === 'Business Process' && risk.RATING === 'Low'
            );
            setRiskMappingBPLR(bp_risk_filtered_lr)

            //IT
            const it_risk_filtered_hr = sortedRiskMapping.filter(risk =>
                risk.RISK_TYPE === 'IT' && risk.RATING === 'High'
            );
            setRiskMappingITHR(it_risk_filtered_hr);    

            const it_risk_filtered_mr = sortedRiskMapping.filter(risk =>
                risk.RISK_TYPE === 'IT' && risk.RATING === 'Medium'
            );
            setRiskMappingITMR(it_risk_filtered_mr);

            const it_risk_filtered_lr = sortedRiskMapping.filter(risk =>
                risk.RISK_TYPE === 'IT' && risk.RATING === 'Low'
            );
            setRiskMappingITLR(it_risk_filtered_lr)

            //Operational
             const operational_risk_filtered_hr = sortedRiskMapping.filter(risk =>
                risk.RISK_TYPE === 'Operational' && risk.RATING === 'High'
            );
            setRiskMappingOperationalHR(operational_risk_filtered_hr);    

            const operational_risk_filtered_mr = sortedRiskMapping.filter(risk =>
                risk.RISK_TYPE === 'Operational' && risk.RATING === 'Medium'
            );
            setRiskMappingOperationalMR(operational_risk_filtered_mr);

            const operational_risk_filtered_lr = sortedRiskMapping.filter(risk =>
                risk.RISK_TYPE === 'Operational' && risk.RATING === 'Low'
            );
            setRiskMappingOperationalLR(operational_risk_filtered_lr)

             //Entity
             const entity_risk_filtered_hr = sortedRiskMapping.filter(risk =>
                risk.RISK_TYPE === 'Entity Level' && risk.RATING === 'High'
            );
            setRiskMappingEntityHR(entity_risk_filtered_hr);    

            const entity_risk_filtered_mr = sortedRiskMapping.filter(risk =>
                risk.RISK_TYPE === 'Entity Level' && risk.RATING === 'Medium'
            );
            setRiskMappingEntityMR(entity_risk_filtered_mr);

            const entity_risk_filtered_lr = sortedRiskMapping.filter(risk =>
                risk.RISK_TYPE === 'Entity Level' && risk.RATING === 'Low'
            );
            setRiskMappingEntityLR(entity_risk_filtered_lr)


            const formattedRating = (rating) => {
                if (Array.isArray(rating)) {
                    return rating.map(value => ({
                        label: value,
                        value
                    }));
                } else {
                    return [{
                        label: rating,
                        value: rating
                    }];
                }
            };

            const bp_mapping = bp_risk_filtered.map((item) => {

                const formatted = formattedRating(selectedRating[item.RISK_ID] || item.RATING);
                const getIconColor = () => {
                    if (item.RATING === 'High') {
                        return 'error'; // Or use a specific color code if "warning" is not valid
                    } else if (item.RATING === 'Medium') {
                        return 'warning';
                    } else if (item.RATING === 'Low') {
                        return 'success';
                    }
                    return undefined;
                };

                return {
                    key: item.RISK_ID,
                    label: (
                        <React.Fragment>
                            <mui.Box>

                                <mui.Typography variant="subtitle2" style={{ fontWeight: 'bold' }}>
                                    {item.RATING && (
                                        <TurnedInIcon color={getIconColor()} sx={{ fontSize: '18px' }} />
                                    )} {item.RISK_ID}
                                </mui.Typography>
                                <mui.Typography variant="caption">
                                    {item.RISK_DESCRIPTION}
                                </mui.Typography>
                            </mui.Box>
                            <Divider sx={{ width: '100%' }} />
                        </React.Fragment>
                    ),
                    content: (
                        <React.Fragment>
                            <mui.Box sx={{ display: 'flex', alignItems: 'right', justifyContent: 'flex-end', marginTop: '-30px', textAlign: 'center' }}>
                                <Chip
                                    icon={<LinkOffIcon color="success" />}
                                    label={
                                        <mui.Typography variant="caption">
                                            {`Tag `}
                                            <strong>{item.RISK_ID}</strong>
                                            {` as not relevant`}
                                        </mui.Typography>
                                    }
                                    onClick={() => handleNotRelevant(item)}
                                />
                            </mui.Box>

                            <mui.Typography variant="subtitle2" style={{ marginBottom: '10px', marginTop: '-20px', fontWeight: 'bold' }}>
                                General Information:
                            </mui.Typography>

                            <mui.Paper sx={{ minWidth: '65vw', padding: '20px', height: '100%' }}>
                                <NormalTextField
                                    label="Risk ID"
                                    value={item.RISK_ID}
                                />
                                <NormalTextField
                                    label="Risk Name"
                                    value={item.RISK_NAME}
                                />
                                <NormalTextField
                                    isMultiLine={true}
                                    rows="5"
                                    label="Risk Description"
                                    value={item.RISK_DESCRIPTION}
                                />
                            </mui.Paper>

                            <mui.Typography variant="subtitle2" style={{ marginBottom: '10px', marginTop: '20px', fontWeight: 'bold' }}>
                                Risk Rating:
                            </mui.Typography>

                            <mui.Paper sx={{ minWidth: '65vw', padding: '20px', height: '100%' }}>
                                <div style={{ marginTop: '10px', marginBottom: '18px', position: 'relative' }}>
                                    <MultipleSelect
                                        isMultiSelect={false}
                                        placeholderText="Select Rating"
                                        selectOptions={riskLevelOption}
                                        defaultvalue={formatted ? formatted : ''}
                                        selectedOptions={formatted ? formatted : ''}
                                        handleChange={(selectedType) => handleRiskRatingChange(item.id, selectedType)}
                                    />
                                    <NormalTextField
                                        name="RATING_RATIONALE"
                                        label="Risk Rating Rationale"
                                        isMultiLine={true}
                                        rows="5"
                                        value={riskRating.RATING_RATIONALE}
                                        onChange={(e) => handleRationaleChange(item.id, e)}
                                        onBlur={(e) => handleRationaleBlur(item.id, e)}
                                    />
                                    <mui.Typography variant="caption" style={{ marginBottom: '10px', color: "grey" }}>
                                        Provide a brief explanation that outlines the basis for the assigned rating
                                    </mui.Typography>


                                </div>
                            </mui.Paper>

                        </React.Fragment>
                    )
                };
            });
            if (bp_mapping) {
                setBPMapping(bp_mapping)
            }
            if (bp_risk_filtered) {
                setBPRiskList(bp_risk_filtered)
            }

            if(it_risk_filtered){
                setITRiskList(it_risk_filtered)
            }

            if(operational_risk_filtered){
                setOperationalRiskList(operational_risk_filtered)
            }

            if(entity_risk_filtered){
                setEntityRiskList(entity_risk_filtered)
            }

            const it_mapping = it_risk_filtered.map((item) => {
                const getIconColor = () => {
                    if (item.RATING === 'High') {
                        return 'error'; // Or use a specific color code if "warning" is not valid
                    } else if (item.RATING === 'Medium') {
                        return 'warning';
                    } else if (item.RATING === 'Low') {
                        return 'success';
                    }
                    return undefined;
                };

                const formatted = formattedRating(selectedRating[item.RISK_ID] || item.RATING);

                return {
                    key: item.RISK_ID,
                    label: (
                        <React.Fragment>
                            <mui.Box>
                                <mui.Typography variant="subtitle2" style={{ fontWeight: 'bold' }}>
                                    {item.RATING && (
                                        <TurnedInIcon color={getIconColor()} sx={{ fontSize: '18px' }} />
                                    )} {item.RISK_ID}
                                </mui.Typography>
                                <mui.Typography variant="caption">
                                    {item.RISK_DESCRIPTION}
                                </mui.Typography>
                            </mui.Box>
                            <Divider sx={{ width: '100%' }} />
                        </React.Fragment>
                    ),
                    content: (
                        <React.Fragment>
                            <mui.Box sx={{ display: 'flex', alignItems: 'right', justifyContent: 'flex-end', marginTop: '-30px', textAlign: 'center' }}>
                                <Chip
                                    icon={<LinkOffIcon color="success" />}
                                    label={
                                        <mui.Typography variant="caption">
                                            {`Tag `}
                                            <strong>{item.RISK_ID}</strong>
                                            {` as not relevant`}
                                        </mui.Typography>
                                    }
                                    onClick={() => handleNotRelevant(item)}
                                />
                            </mui.Box>

                            <mui.Typography variant="subtitle2" style={{ marginBottom: '10px', marginTop: '-20px', fontWeight: 'bold' }}>
                                General Information:
                            </mui.Typography>

                            <mui.Paper sx={{ minWidth: '65vw', padding: '20px', height: '100%' }}>
                                <NormalTextField
                                    label="Risk ID"
                                    value={item.RISK_ID}
                                />
                                <NormalTextField
                                    label="Risk Name"
                                    value={item.RISK_NAME}
                                />
                                <NormalTextField
                                    isMultiLine={true}
                                    rows="5"
                                    label="Risk Description"
                                    value={item.RISK_DESCRIPTION}
                                />
                            </mui.Paper>

                            <mui.Typography variant="subtitle2" style={{ marginBottom: '10px', marginTop: '20px', fontWeight: 'bold' }}>
                                Risk Rating:
                            </mui.Typography>

                            <mui.Paper sx={{ padding: '20px', height: '100%' }}>
                                <div style={{ marginTop: '10px', marginBottom: '18px', position: 'relative' }}>
                                    <MultipleSelect
                                        isMultiSelect={false}
                                        placeholderText="Select Rating"
                                        selectOptions={riskLevelOption}
                                        defaultvalue={formatted ? formatted : ''}
                                        selectedOptions={formatted ? formatted : ''}
                                        handleChange={(selectedType) => handleRiskRatingChange(item.id, selectedType)}
                                    />
                                    <NormalTextField
                                        name="RATING_RATIONALE"
                                        label="Risk Rating Rationale"
                                        isMultiLine={true}
                                        rows="5"
                                        value={riskRating.RATING_RATIONALE}
                                        onChange={(e) => handleRationaleChange(item.id, e)}
                                        onBlur={(e) => handleRationaleBlur(item.id, e)}
                                    />
                                    <mui.Typography variant="caption" style={{ marginBottom: '10px', color: "grey" }}>
                                        Provide a brief explanation that outlines the basis for the assigned rating
                                    </mui.Typography>
                                </div>
                            </mui.Paper>
                        </React.Fragment>
                    )
                };
            });
            setITMapping(it_mapping)

            const ops_mapping = operational_risk_filtered.map((item) => {

                const formatted = formattedRating(selectedRating[item.RISK_ID] || item.RATING);
                const getIconColor = () => {
                    if (item.RATING === 'High') {
                        return 'error'; // Or use a specific color code if "warning" is not valid
                    } else if (item.RATING === 'Medium') {
                        return 'warning';
                    } else if (item.RATING === 'Low') {
                        return 'success';
                    }
                    return undefined;
                };
                return {
                    key: item.RISK_ID,
                    label: (
                        <React.Fragment>
                            <mui.Box>
                                <mui.Typography variant="subtitle2" style={{ fontWeight: 'bold' }}>
                                    {item.RATING && (
                                        <TurnedInIcon color={getIconColor()} sx={{ fontSize: '18px' }} />
                                    )} {item.RISK_ID}
                                </mui.Typography>
                                <mui.Typography variant="caption">
                                    {item.RISK_DESCRIPTION}
                                </mui.Typography>
                            </mui.Box>
                            <Divider sx={{ width: '100%' }} />
                        </React.Fragment>
                    ),
                    content: (
                        <React.Fragment>
                            <mui.Box sx={{ display: 'flex', alignItems: 'right', justifyContent: 'flex-end', marginTop: '-30px', textAlign: 'center' }}>
                                <Chip
                                    icon={<LinkOffIcon color="success" />}
                                    label={
                                        <mui.Typography variant="caption">
                                            {`Tag `}
                                            <strong>{item.RISK_ID}</strong>
                                            {` as not relevant`}
                                        </mui.Typography>
                                    }
                                    onClick={() => handleNotRelevant(item)}
                                />
                            </mui.Box>

                            <mui.Typography variant="subtitle2" style={{ marginBottom: '10px', marginTop: '-20px', fontWeight: 'bold' }}>
                                General Information:
                            </mui.Typography>

                            <mui.Paper sx={{ minWidth: '65vw', padding: '20px', height: '100%' }}>
                                <NormalTextField
                                    label="Risk ID"
                                    value={item.RISK_ID}
                                />
                                <NormalTextField
                                    label="Risk Name"
                                    value={item.RISK_NAME}
                                />
                                <NormalTextField
                                    isMultiLine={true}
                                    rows="5"
                                    label="Risk Description"
                                    value={item.RISK_DESCRIPTION}
                                />
                            </mui.Paper>

                            <mui.Typography variant="subtitle2" style={{ marginBottom: '10px', marginTop: '20px', fontWeight: 'bold' }}>
                                Risk Rating:
                            </mui.Typography>

                            <mui.Paper sx={{ minWidth: '65vw', padding: '20px', height: '100%' }}>
                                <div style={{ marginTop: '10px', marginBottom: '18px', position: 'relative' }}>
                                    <MultipleSelect
                                        isMultiSelect={false}
                                        placeholderText="Select Rating"
                                        selectOptions={riskLevelOption}
                                        defaultvalue={formatted ? formatted : ''}
                                        selectedOptions={formatted ? formatted : ''}
                                        handleChange={(selectedType) => handleRiskRatingChange(item.id, selectedType)}
                                    />
                                    <NormalTextField
                                        name="RATING_RATIONALE"
                                        label="Risk Rating Rationale"
                                        isMultiLine={true}
                                        rows="5"
                                        value={riskRating.RATING_RATIONALE}
                                        onChange={(e) => handleRationaleChange(item.id, e)}
                                        onBlur={(e) => handleRationaleBlur(item.id, e)}
                                    />
                                    <mui.Typography variant="caption" style={{ marginBottom: '10px', color: "grey" }}>
                                        Provide a brief explanation that outlines the basis for the assigned rating
                                    </mui.Typography>
                                </div>
                            </mui.Paper>
                        </React.Fragment>
                    )
                };
            });
            setOPSMapping(ops_mapping)

            const entity_mapping = entity_risk_filtered.map((item) => {

                const formatted = formattedRating(selectedRating[item.RISK_ID] || item.RATING);
                const getIconColor = () => {
                    if (item.RATING === 'High') {
                        return 'error'; // Or use a specific color code if "warning" is not valid
                    } else if (item.RATING === 'Medium') {
                        return 'warning';
                    } else if (item.RATING === 'Low') {
                        return 'success';
                    }
                    return undefined;
                };

                return {
                    key: item.RISK_ID,
                    label: (
                        <React.Fragment>
                            <mui.Box>
                                <mui.Typography variant="subtitle2" style={{ fontWeight: 'bold' }}>
                                    {item.RATING && (
                                        <TurnedInIcon color={getIconColor()} sx={{ fontSize: '18px' }} />
                                    )} {item.RISK_ID}
                                </mui.Typography>
                                <mui.Typography variant="caption">
                                    {item.RISK_DESCRIPTION}
                                </mui.Typography>
                            </mui.Box>
                            <Divider sx={{ width: '100%' }} />
                        </React.Fragment>
                    ),
                    content: (
                        <React.Fragment>
                            <mui.Box sx={{ display: 'flex', alignItems: 'right', justifyContent: 'flex-end', marginTop: '-30px', textAlign: 'center' }}>
                                <Chip
                                    icon={<LinkOffIcon color="success" />}
                                    label={
                                        <mui.Typography variant="caption">
                                            {`Tag `}
                                            <strong>{item.RISK_ID}</strong>
                                            {` as not relevant`}
                                        </mui.Typography>
                                    }
                                    onClick={() => handleNotRelevant(item)}
                                />
                            </mui.Box>

                            <mui.Typography variant="subtitle2" style={{ marginBottom: '10px', marginTop: '-20px', fontWeight: 'bold' }}>
                                General Information:
                            </mui.Typography>

                            <mui.Paper sx={{ minWidth: '65vw', padding: '20px', height: '100%' }}>
                                <NormalTextField
                                    label="Risk ID"
                                    value={item.RISK_ID}
                                />
                                <NormalTextField
                                    label="Risk Name"
                                    value={item.RISK_NAME}
                                />
                                <NormalTextField
                                    isMultiLine={true}
                                    rows="5"
                                    label="Risk Description"
                                    value={item.RISK_DESCRIPTION}
                                />
                            </mui.Paper>

                            <mui.Typography variant="subtitle2" style={{ marginBottom: '10px', marginTop: '20px', fontWeight: 'bold' }}>
                                Risk Rating:
                            </mui.Typography>

                            <mui.Paper sx={{ minWidth: '65vw', padding: '20px', height: '100%' }}>
                                <div style={{ marginTop: '10px', marginBottom: '18px', position: 'relative' }}>
                                    <MultipleSelect
                                        isMultiSelect={false}
                                        placeholderText="Select Rating"
                                        selectOptions={riskLevelOption}
                                        defaultvalue={formatted ? formatted : ''}
                                        selectedOptions={formatted ? formatted : ''}
                                        handleChange={(selectedType) => handleRiskRatingChange(item.id, selectedType)}
                                    />
                                    <NormalTextField
                                        name="RATING_RATIONALE"
                                        label="Risk Rating Rationale"
                                        isMultiLine={true}
                                        rows="5"
                                        value={riskRating.RATING_RATIONALE}
                                        onChange={(e) => handleRationaleChange(item.id, e)}
                                        onBlur={(e) => handleRationaleBlur(item.id, e)}
                                    />
                                    <mui.Typography variant="caption" style={{ marginBottom: '10px', color: "grey" }}>
                                        Provide a brief explanation that outlines the basis for the assigned rating
                                    </mui.Typography>
                                </div>
                            </mui.Paper>
                        </React.Fragment>
                    )
                };
            });
            setEntityMapping(entity_mapping)

        } else {

            setSelectedRating({});
            setBPMapping([])
            setITMapping([])
            setOPSMapping([])
            setEntityMapping([])
            setMappedRisk([])
            setBPRiskList([])
            setITRiskList([])
            setRiskMappingBPHR([])
        }
    }

    const control_column = [
        { field: 'id', headerName: '#', flex: .2 },
        { field: 'CONTROL_ID', headerName: 'Control Ref', flex: .3 },
        { field: 'CONTROL_TITLE', headerName: 'Control Name', flex: .5 },
        { field: 'CONTROL_DESCRIPTION', headerName: 'Description', flex: 1},
        { field: 'CONTROL_TYPE', headerName: 'Control Type', flex: .3 },
    ];

    const control_rows = controls.map((control, index) => ({
        id: index + 1,
        CONTROL_ID: control.CONTROL_ID || '-',
        CONTROL_TITLE: control.CONTROL_TITLE || '-',
        CONTROL_DESCRIPTION: control.CONTROL_DESCRIPTION || '-',
        CONTROL_TYPE: control.CONTROL_TYPE || '-',
        controlID: control.id
    }));

    const control_rows_mapped = mappedControls.map((control, index) => ({
        id: index + 1,
        CONTROL_ID: control.CONTROL_ID || '-',
        CONTROL_TITLE: control.CONTROL_TITLE || '-',
        CONTROL_DESCRIPTION: control.CONTROL_DESCRIPTION || '-',
        CONTROL_TYPE: control.CONTROL_TYPE || '-',
        controlID: control.id
    }));

    const columns = [
        { field: 'id', headerName: '#', flex: .2 },
        { field: 'RISK_ID', headerName: 'Risk ID', flex: .3 },
        { field: 'RISK_NAME', headerName: 'Risk Name', flex: .5 },
        {
            field: 'RISK_TYPE',
            headerName: 'Risk Type',
            sortable: false,
            flex: .2
        },

        {
            field: 'RISK_DESCRIPTION',
            headerName: 'Description',
            sortable: false,
            flex: 1
        },
    ];

    const rows = bp_risk.map((risk, index) => ({
        id: index + 1,
        RISK_ID: risk.RISK_ID || '-',
        RISK_NAME: risk.RISK_NAME || '-',
        RISK_TYPE: risk.RISK_TYPE || '-',
        RISK_DESCRIPTION: risk.RISK_DESCRIPTION || '-',
        riskID: risk.id
    }));

    const it_rows = it_risk.map((risk, index) => ({
        id: index + 1,
        RISK_ID: risk.RISK_ID || '-',
        RISK_NAME: risk.RISK_NAME || '-',
        RISK_TYPE: risk.RISK_TYPE || '-',
        RISK_DESCRIPTION: risk.RISK_DESCRIPTION || '-',
        riskID: risk.id
    }));

    const operational_rows = operational_risk.map((risk, index) => ({
        id: index + 1,
        RISK_ID: risk.RISK_ID || '-',
        RISK_NAME: risk.RISK_NAME || '-',
        RISK_TYPE: risk.RISK_TYPE || '-',
        RISK_DESCRIPTION: risk.RISK_DESCRIPTION || '-',
        riskID: risk.id
    }));

    const entity_rows = entity_risk.map((risk, index) => ({
        id: index + 1,
        RISK_ID: risk.RISK_ID || '-',
        RISK_NAME: risk.RISK_NAME || '-',
        RISK_TYPE: risk.RISK_TYPE || '-',
        RISK_DESCRIPTION: risk.RISK_DESCRIPTION || '-',
        riskID: risk.id
    }));

    const handleOpenModal = () => {
        setOpenModal(true);
    };

    const handleModalClose = (event, reason) => {
        if (reason == 'backdropClick') {
            setOpenModal(true)
        }
        else {
            setOpenModal(false);
        }
    };

    const handleRationaleChange = (risk_id, e) => {
        const { name, value } = e.target;

        if (saveTimeout.current) {
            clearTimeout(saveTimeout.current);
        }
        const updatedData = {
            ...riskRating,
            [name]: value,
            RISK_ID: risk_id,
            APP_NAME: id,
            COMPANY_ID: company_id
        };

        setRiskRating(updatedData);

        setRatingRationale(updatedData.RATING_RATIONALE)
        // Save changes with the updated state
        saveTimeout.current = setTimeout(() => {
            saveRating(updatedData)
        }, 1000);

    };

    const handleRationaleBlur = (risk_id, e) => {
        const { name, value } = e.target;

        const updatedData = {
            ...riskRating,
            [name]: value,
            RISK_ID: risk_id,
            APP_NAME: id,
            COMPANY_ID: company_id
        };

        setRiskRating(updatedData);
        saveRating(updatedData)
    };


    const handleRiskRatingChange = async (risk_id, selectedType) => {
        const rating = selectedType?.value || selectedType;

        // Get the project ID from URL or localStorage or fetch from API if not available
        const urlParams = new URLSearchParams(window.location.search);
        let projectId = urlParams.get('project') || localStorage.getItem('currentProjectId');
        
        // If no project ID is found in URL or localStorage, we need to fetch available projects
        if (!projectId) {
            try {
                // Try to get the first available project for this company
                const projects = await auditService.fetchProjects();
                if (projects && projects.length > 0) {
                    // Filter projects for this company
                    const companyProjects = projects.filter(p => p.COMPANY_ID === company_id);
                    if (companyProjects.length > 0) {
                        projectId = companyProjects[0].id; // Use the first project's ID
                        localStorage.setItem('currentProjectId', projectId); // Save for future use
                    }
                }
            } catch (error) {
                console.error('Error fetching projects:', error);
            }
        }

        const formatted_rating = {
            label: rating,
            value: rating
        }

        setRating(formatted_rating)

        const updatedData = {
            ...riskRating,
            RATING: rating,
            RISK_ID: risk_id,
            APP_NAME: id,
            COMPANY_ID: company_id,
            AUDIT_LIST: projectId
        };

        try {
            await saveRating(updatedData);

            const risk = current_risk.find(item => item.id === risk_id)

            fetchRiskMapped()

            setSelectedRisk(risk)

        } catch (error) {
            console.error('Error saving rating:', error);
        }
    };

    const handleClick = (risk) => {
        // Show loading indicator immediately
        setDialogLoading(true);
        
        // Close any open dialog first to prevent state inconsistencies
        if (openConsolidatedDialog) {
            setOpenConsolidatedDialog(false);
        }
        
        // Log the input risk for debugging
        console.log("handleClick received risk:", risk);
        
        // Use both strategies to find the complete risk object
        // First try to find in the risks array by ID
        const riskId = risk.riskID || risk.id;
        let riskObj = risks.find(r => r.id === riskId);
        
        // If not found in risks array, try to find in mappedRisk array
        if (!riskObj) {
            riskObj = mappedRisk.find(r => r.id === riskId);
        }
        
        // If still not found, use the row data as a fallback
        riskObj = riskObj || risk;
        
        // Find mapped risk info from mappedRisk array to get the current RATING if available
        let currentRating = risk.RATING; // Start with any rating passed in
        if (!currentRating || currentRating === 'Not Set') {
            const mappedRiskInfo = mappedRisk.find(item => item.id === riskId);
            if (mappedRiskInfo && mappedRiskInfo.RATING) {
                currentRating = mappedRiskInfo.RATING;
                console.log(`Found rating from mappedRisk: ${currentRating}`);
            }
        }
        
        // Create a complete risk object with all required properties
        const formattedRisk = {
            id: riskObj.id || risk.id || riskId,
            RISK_ID: riskObj.RISK_ID || risk.RISK_ID || '',
            RISK_NAME: riskObj.RISK_NAME || risk.RISK_NAME || 'Risk',
            RISK_TYPE: riskObj.RISK_TYPE || risk.RISK_TYPE || '',
            RISK_DESCRIPTION: riskObj.RISK_DESCRIPTION || risk.RISK_DESCRIPTION || '',
            RATING: currentRating || 'Not Set'
        };
        
        // Log the fully formatted risk object
        console.log("Formatted Risk for Dialog:", formattedRisk);
        
        // Set the selected risk for the consolidated dialog
        setSelectedConsolidatedRisk(formattedRisk);
        
        // Get risk ID from the most reliable source
        const risk_id = riskId;
        
        // Open the dialog immediately with a loading state
        // This will make the UI feel more responsive
        setOpenConsolidatedDialog(true);
        
        // Now do the data fetching in parallel
        Promise.all([
            saveChanges(risk_id),
            fetchRiskMapped()
        ]).then(() => {
            // Hide loading when both operations are complete
            setDialogLoading(false);
        }).catch(error => {
            console.error("Error in handleClick:", error);
            // Still hide loading even if there's an error
            setDialogLoading(false);
        });
    };

    const handleUnmapControlClick = (control) => {
        const control_id = control.controlID

        // Get the project ID from URL or localStorage or fetch from API if not available
        const fetchProjectId = async () => {
            const urlParams = new URLSearchParams(window.location.search);
            let projectId = urlParams.get('project') || localStorage.getItem('currentProjectId');
            
            // If no project ID is found in URL or localStorage, we need to fetch available projects
            if (!projectId) {
                try {
                    // Try to get the first available project for this company
                    const projects = await auditService.fetchProjects();
                    if (projects && projects.length > 0) {
                        // Filter projects for this company
                        const companyProjects = projects.filter(p => p.COMPANY_ID === company_id);
                        if (companyProjects.length > 0) {
                            projectId = companyProjects[0].id; // Use the first project's ID
                            localStorage.setItem('currentProjectId', projectId); // Save for future use
                        }
                    }
                } catch (error) {
                    console.error('Error fetching projects:', error);
                }
            }
            
            return projectId;
        };
        
        fetchProjectId().then(projectId => {
            const updatedData = {
                ...riskRating,
                ACTION: 'UNMAP',
                CONTROL_ID: control_id,
                RISK_ID: selectedRisk.id,
                APP_NAME: id,
                COMPANY_ID: company_id,
                AUDIT_LIST: projectId
            };
            
            UnmapControl(updatedData);
        });
    }

    const handleMapControlClick = (control) => {
        const control_id = control.controlID

        // Get the project ID from URL or localStorage or fetch from API if not available
        const fetchProjectId = async () => {
            const urlParams = new URLSearchParams(window.location.search);
            let projectId = urlParams.get('project') || localStorage.getItem('currentProjectId');
            
            // If no project ID is found in URL or localStorage, we need to fetch available projects
            if (!projectId) {
                try {
                    // Try to get the first available project for this company
                    const projects = await auditService.fetchProjects();
                    if (projects && projects.length > 0) {
                        // Filter projects for this company
                        const companyProjects = projects.filter(p => p.COMPANY_ID === company_id);
                        if (companyProjects.length > 0) {
                            projectId = companyProjects[0].id; // Use the first project's ID
                            localStorage.setItem('currentProjectId', projectId); // Save for future use
                        }
                    }
                } catch (error) {
                    console.error('Error fetching projects:', error);
                }
            }
            
            return projectId;
        };
        
        fetchProjectId().then(projectId => {
            const updatedData = {
                ...riskRating,
                CONTROL_ID: control_id,
                RISK_ID: selectedRisk.id,
                APP_NAME: id,
                COMPANY_ID: company_id,
                AUDIT_LIST: projectId
            };
            
            saveControl(updatedData);
        });
    }

    const handleBPRiskClick = () => {
        setOpenBPRiskList(!openBPRiskList);
    };

    const handleITRiskClick = () => {
        setOpenITRiskList(!openITRiskList);
    };

    const handleOperationalRiskClick = () => {
        setOpenOperationalRiskList(!openOperationalRiskList);
    };

    const handleEntityRiskClick = () => {
        setOpenEntityRiskList(!openEntityRiskList);
    };

    const handleBPHRClick = () => {
        setOpenBPHR(!openBPHR);
    };

    const handleITHRClick = () => {
        setOpenITHR(!openITHR);
    };

    const handleOperationalHRClick = () => {
        setOpenOperationalHR(!openOperationalHR);
    };

    const handleEntityHRClick = () => {
        setOpenEntityHR(!openEntityHR);
    };

    const handleBPMRClick = () => {
        setOpenBPMR(!openBPMR);
    };

    const handleITMRClick = () => {
        setOpenITMR(!openITMR);
    };

    const handleOperationalMRClick = () => {
        setOpenOperationalMR(!openOperationalMR);
    };

    const handleEntityMRClick = () => {
        setOpenEntityMR(!openEntityMR);
    };

    const handleBPLRClick = () => {
        setOpenBPLR(!openBPLR);
    };

    const handleITLRClick = () => {
        setOpenBPLR(!openBPLR);
    };

    const handleOperationalLRClick = () => {
        setOpenOperationalLR(!openOperationalLR);
    };

    const handleEntityLRClick = () => {
        setOpenEntityLR(!openEntityLR);
    };

    const handleNotRelevant = (item) => {
        unmapRisk(item.id)
    };

    // Update handleCloseConsolidatedDialog to reset loading state
    const handleCloseConsolidatedDialog = () => {
        setOpenConsolidatedDialog(false);
        setDialogLoading(false);
        
        // Refresh data when dialog is closed, even if no changes were saved
        // This ensures that risk ratings continue to display correctly
        fetchRiskMapped();
        
        // Add a small delay to ensure the UI updates properly
        setTimeout(() => {
            fetchRiskMapping();
        }, 100);
    };

    // Add a handler for when changes are saved in the consolidated dialog
    const handleConsolidatedDialogSave = () => {
        // Refresh data after saving
        fetchRiskMapped();
        fetchRiskMapping();
    };

    const saveControl = async (updatedData) => {
        if (updatedData) {

            let updated_controlmapping;
            try {
                updated_controlmapping = await auditService.updateRiskMappingbyMapID(updatedData.APP_NAME, updatedData.RISK_ID, company_id, updatedData)
               
            } catch (error) {
                console.error('Error updating record:', error);
            }

            if (updated_controlmapping) {
                setSelectedControls(updated_controlmapping)
            }

            fetchMappedControls(updatedData.RISK_ID)
            fetchRiskMapping();

        }
    }

    const UnmapControl = async (updatedData) => {
        if (updatedData) {

            let updated_controlmapping;
            try {
                updated_controlmapping = await auditService.updateRiskMappingbyMapID(updatedData.APP_NAME, updatedData.RISK_ID, company_id, updatedData)
               
            } catch (error) {
                console.error('Error updating record:', error);
            }

            if (updated_controlmapping) {
                setSelectedControls(updated_controlmapping)
            }

            fetchMappedControls(updatedData.RISK_ID)
            fetchRiskMapping();
        }
    }

    const saveRating = async (updatedData) => {
        if (updatedData) {

            let updated_riskmapping;
            try {
                updated_riskmapping = await auditService.updateRiskMappingbyMapID(updatedData.APP_NAME, updatedData.RISK_ID, company_id, updatedData)

            } catch (error) {
                console.error('Error updating record:', error);
            }

            if (updated_riskmapping) {
                setRiskRating(updated_riskmapping)
            }

        }
    }

    const unmapRisk = async (risk_id) => {
        if (!risk_id) {
            console.warn("unmapRisk called with no risk_id");
            return;
        }

        console.log(`Attempting to unmap risk ID: ${risk_id}`);

        try {
            const mappingFound = await auditService.deleteRiskMappingbyMapID(id, risk_id, company_id);
            console.log("Unmap operation result:", mappingFound);
            
            // Refresh data regardless of result to ensure UI is consistent
            await fetchRiskMapped();
            
            // Add a small delay before fetching risk mapping to ensure all state updates are processed
            setTimeout(() => {
                fetchRiskMapping();
            }, 100);
            
        } catch (error) {
            console.error('Error unmapping risk:', error);
            
            // Refresh data even on error to ensure UI state is consistent
            fetchRiskMapped();
            
            // Show an error message if needed
            if (error.response && error.response.status === 404) {
                console.warn(`Risk mapping not found for ID: ${risk_id}`);
            }
        }
    };

    const saveChanges = async (risk_id) => {
        if (!risk_id) {
            return Promise.resolve(null);
        }

        const newMapping = {
            RISK_ID: risk_id,
            APP_NAME: selectedApp.id,
            COMPANY_ID: company_id
        };

        try {
            // Attempt to fetch the existing risk mapping
            const mappingFound = await auditService.fetchRiskMappingbyId(risk_id);
            
            // If mapping already exists, just return it
            if (mappingFound) {
                console.log("Risk mapping already exists:", mappingFound);
                return Promise.resolve(mappingFound);
            } else {
                // Create a new mapping if it doesn't exist
                console.log("Creating new risk mapping for:", risk_id);
                const newRecord = await auditService.createRiskMapping(newMapping);
                // Refresh data after creating a new mapping
                await fetchRiskMapped();
                return Promise.resolve(newRecord);
            }
        } catch (error) {
            console.error("Error in saveChanges:", error);
            if (error.response && error.response.status === 404) {
                // Create new mapping if 404 error (not found)
                try {
                    console.log("Creating new risk mapping after 404:", risk_id);
                    const newRecord = await auditService.createRiskMapping(newMapping);
                    await fetchRiskMapped();
                    return Promise.resolve(newRecord);
                } catch (createError) {
                    console.error("Error creating risk mapping:", createError);
                    return Promise.reject(createError);
                }
            } else {
                return Promise.reject(error);
            }
        }
    };

    const isRiskIDMapped = (riskID, mappedRisks) => {
        return mappedRisks.some(mappedRisk => mappedRisk.id === riskID);
    };

    // Function to fetch control count for a specific risk
    const fetchControlCountForRisk = async (riskId) => {
        if (!riskId) return 0;
        
        try {
            const mappedControlsData = await auditService.fetchMappedControls(id, riskId, company_id);
            console.log("Fetched control data for risk ID:", riskId, mappedControlsData);
            
            if (mappedControlsData && mappedControlsData.length > 0 && mappedControlsData[0].CONTROL_DETAILS) {
                const count = mappedControlsData[0].CONTROL_DETAILS.length;
                
                // Update the control counts map
                setControlCountsMap(prev => ({
                    ...prev,
                    [riskId]: count
                }));
                
                return count;
            }
        } catch (error) {
            console.error("Error fetching control count for risk ID:", riskId, error);
        }
        
        return 0;
    };

    const renderAuditPrepButton = (params) => {
        const risk = params.row;

        // Check if the riskID is found in mappedRisk
        const isMapped = isRiskIDMapped(risk.riskID, mappedRisk);

        // Debug logging for mappedRisk data
        if (!mappedRisk || mappedRisk.length === 0) {
            console.warn("mappedRisk array is empty or undefined:", mappedRisk);
        }

        // Find the mapped risk to get the RISK_RATING
        const mappedRiskInfo = mappedRisk.find(item => item.id === risk.riskID);
        
        // Force the UI to show as mapped if the risk ID is in the mappedRisk array,
        // even if we can't find the specific object with detailed information
        const shouldRenderMapped = isMapped || !!mappedRiskInfo;
        
        // Log the mappedRiskInfo for debugging
        console.log("Mapped risk info for risk ID", risk.riskID, ":", mappedRiskInfo, "isMapped:", isMapped, "shouldRenderMapped:", shouldRenderMapped);
        
        // More robust handling for risk rating
        let riskRating = 'Not Set';
        if (mappedRiskInfo) {
            if (mappedRiskInfo.RATING) {
                riskRating = mappedRiskInfo.RATING;
                console.log(`Risk rating found for ${risk.riskID}: ${riskRating}`);
            } else {
                console.warn(`RATING property missing for risk ${risk.riskID} in mappedRiskInfo:`, mappedRiskInfo);
            }
        } else {
            console.warn(`No mappedRiskInfo found for risk ID: ${risk.riskID}`);
        }
        
        // Get the color based on risk rating
        const getRatingColor = (rating) => {
            // Always return an object with both color and bg properties
            if (!rating || rating === 'Not Set') {
                return {color: 'text.disabled', bg: 'rgba(0, 0, 0, 0.04)'};
            }
            
            switch(rating) {
                case 'High':
                    return {color: '#d32f2f', bg: 'rgba(211, 47, 47, 0.08)'};
                case 'Medium':
                    return {color: '#ed6c02', bg: 'rgba(237, 108, 2, 0.08)'};
                case 'Low':
                    return {color: '#2e7d32', bg: 'rgba(46, 125, 50, 0.08)'};
                default:
                    return {color: 'text.disabled', bg: 'rgba(0, 0, 0, 0.04)'};
            }
        };
        
        // Get control count and handle all possible cases
        const getControlCount = () => {
            if (!mappedRiskInfo) {
                console.warn(`No mappedRiskInfo available for control count calculation: ${risk.riskID}`);
                return 0;
            }
            
            // First check if we have CONTROL_DETAILS in the mappedRiskInfo
            if (mappedRiskInfo.CONTROL_DETAILS) {
                console.log("CONTROL_DETAILS for risk", risk.riskID, ":", mappedRiskInfo.CONTROL_DETAILS);
                
                if (Array.isArray(mappedRiskInfo.CONTROL_DETAILS)) {
                    const count = mappedRiskInfo.CONTROL_DETAILS.length;
                    console.log(`Found ${count} controls in CONTROL_DETAILS for risk ${risk.riskID}`);
                    return count;
                } else {
                    console.warn(`CONTROL_DETAILS exists but is not an array for risk ${risk.riskID}:`, mappedRiskInfo.CONTROL_DETAILS);
                }
            } else {
                console.log(`No CONTROL_DETAILS property found for risk ${risk.riskID}`);
            }
            
            // If no CONTROL_DETAILS, check if we have a count in the controlCountsMap
            if (controlCountsMap[risk.riskID] !== undefined) {
                const count = controlCountsMap[risk.riskID];
                console.log(`Using count from controlCountsMap for risk ${risk.riskID}: ${count}`);
                return count;
            }
            
            // If we don't have a count yet, trigger a fetch (but return 0 for now)
            // This will update the state for the next render
            console.log(`No control count found for risk ${risk.riskID}, triggering fetch`);
            fetchControlCountForRisk(risk.riskID);
            
            // For any other case, return 0 for safety
            return 0;
        };
        
        // Calculate the control count
        const controlCount = getControlCount();

        // Define the UI for when the risk is mapped
        const mappedDisplay = (
            <mui.Tooltip 
                title={
                    <mui.Box sx={{ p: 0.5 }}>
                        <mui.Typography variant="body2" sx={{ fontWeight: 600 }}>
                            Risk Rating: {riskRating}
                        </mui.Typography>
                        {controlCount > 0 && (
                            <mui.Typography variant="body2">
                                {controlCount} controls mapped
                            </mui.Typography>
                        )}
                        <mui.Typography variant="caption" sx={{ display: 'block', mt: 0.5, color: 'text.secondary' }}>
                            Click to manage
                        </mui.Typography>
                    </mui.Box>
                } 
                arrow
            >
                <mui.Box 
                    sx={{ 
                        display: 'flex', 
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        position: 'relative',
                        '&:hover .remove-button': {
                            opacity: 1,
                        }
                    }}
                    onClick={() => {
                        // Open the consolidated dialog with this risk
                        const riskObj = risks.find(r => r.id === risk.riskID) || risk;
                        
                        // Ensure risk object has all needed properties including the rating
                        // Use the same format as handleClick for consistency
                        const formattedRisk = {
                            id: riskObj.id || risk.riskID,
                            RISK_ID: riskObj.RISK_ID || risk.RISK_ID,
                            RISK_NAME: riskObj.RISK_NAME || risk.RISK_NAME || 'Risk',
                            RISK_TYPE: riskObj.RISK_TYPE || risk.RISK_TYPE || '',
                            RISK_DESCRIPTION: riskObj.RISK_DESCRIPTION || risk.RISK_DESCRIPTION || '',
                            RATING: riskRating // Use the current risk rating from the UI
                        };
                        
                        console.log("Opening dialog with risk object:", formattedRisk);
                        
                        // Use handleClick to ensure consistent behavior
                        handleClick(formattedRisk);
                    }}
                >
                    {/* Unified status display container */}
                    <mui.Box sx={{ 
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 0.75,
                        height: 26
                    }}>
                        {/* Risk Rating Indicator */}
                        <mui.Box sx={{
                            width: 8,
                            height: 8,
                            borderRadius: '50%',
                            backgroundColor: getRatingColor(riskRating).color,
                            flexShrink: 0
                        }} />
                        
                        {/* Risk Rating Text */}
                        <mui.Typography sx={{
                            fontSize: '0.75rem',
                            fontWeight: 600,
                            color: getRatingColor(riskRating).color,
                            minWidth: 42,
                            textAlign: 'left'
                        }}>
                            {riskRating === 'Not Set' ? '-' : riskRating}
                        </mui.Typography>
                        
                        {/* Separator - always show for consistency */}
                        <mui.Divider orientation="vertical" flexItem sx={{ height: 16 }} />

                        {/* Control count with shield icon - always show for consistency */}
                        <mui.Box sx={{ 
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.5,
                            fontSize: '0.75rem',
                            color: controlCount > 0 ? 'primary.main' : 'text.disabled',
                            minWidth: 24
                        }}>
                            <SecurityIcon sx={{ fontSize: 12 }} />
                            {controlCount}
                        </mui.Box>
                    </mui.Box>
                    
                    {/* Remove button that appears on hover */}
                    <mui.IconButton
                        className="remove-button"
                        size="small"
                        onClick={(e) => {
                            e.stopPropagation(); // Prevent opening the dialog
                            // Create an object with the expected structure for handleNotRelevant
                            const item = { id: risk.riskID };
                            handleNotRelevant(item);
                        }}
                        sx={{
                            position: 'absolute',
                            top: -8,
                            right: -8,
                            color: 'rgba(211, 47, 47, 0.7)',
                            padding: '2px',
                            opacity: 0,
                            transition: 'opacity 0.2s',
                            bgcolor: 'background.paper',
                            boxShadow: 1,
                            width: 16,
                            height: 16,
                            '&:hover': {
                                backgroundColor: 'background.paper',
                                color: '#d32f2f',
                            }
                        }}
                    >
                        <mui.Icon sx={{ fontSize: 10 }}>close</mui.Icon>
                    </mui.IconButton>
                </mui.Box>
            </mui.Tooltip>
        );

        // Define the UI for when the risk is not mapped
        const notMappedTooltip = (
            <mui.Tooltip title="Mark as relevant" arrow placement="top">
                <mui.IconButton
                    size="small"
                    onClick={() => handleClick(risk)}
                    sx={{
                        color: 'rgba(25, 118, 210, 0.7)',
                        padding: '4px',
                        '&:hover': {
                            backgroundColor: 'transparent',
                            color: 'primary.main',
                        }
                    }}
                >
                    <mui.Icon sx={{ fontSize: 18 }}>add</mui.Icon>
                </mui.IconButton>
            </mui.Tooltip>
        );

        // Render the appropriate UI based on mapped state
        return shouldRenderMapped ? mappedDisplay : notMappedTooltip;
    };

    const isControlIDMapped = (controlID, mappedControls) => {
        return mappedControls.some(mappedControls => mappedControls.id === controlID);
    };

    const renderMapControlButton = (params) => {
        const control = params.row;

        const isMapped = isControlIDMapped(control.controlID, mappedControls);

        const mappedTooltip = (
            <Tooltip title="Mapped" arrow>
                <mui.IconButton
                    size="small"
                >
                    <LinkIcon style={{ color: 'gray' }} /> {/* Different icon color for mapped state */}
                </mui.IconButton>
            </Tooltip>
        );

        const notMappedTooltip = (
            <Tooltip title="Map Control" arrow>
            <mui.IconButton
                size="small"
                onClick={() => handleMapControlClick(control)}
            >
                <AddCircleRounded style={{ color: '#1976d2' }} /> {/* Different icon color for mapped state */}
            </mui.IconButton>
        </Tooltip>
        );

        return isMapped ? mappedTooltip : notMappedTooltip;
    };

    const renderUnMapControlButton = (params) => {
        const control = params.row;
        return (
            <Tooltip title="Remove Mapping" arrow>
                <mui.IconButton
                    size="small"
                    onClick={() => handleUnmapControlClick(control)}
                >
                    <RemoveCircleIcon style={{ color: 'grey' }} /> {/* Different icon color for mapped state */}
                </mui.IconButton>
            </Tooltip>
        )
    };


    const fetchMappedControls = async (riskid) => {

        let mapped_controls;
            try {
                mapped_controls = await auditService.fetchMappedControls(id, riskid, company_id)

            } catch (fetchError) {
                console.error('Error fetching controls record:', fetchError);
                setMappedControls([])
            }

            if (mapped_controls) {

                 setMappedControls(mapped_controls[0].CONTROL_DETAILS || []);

                 const rating_record = {
                    label: mapped_controls[0].RATING,
                    value: mapped_controls[0].RATING,
                 }

                setRating(rating_record)
                setRatingRationale(mapped_controls[0].RATING_RATIONALE)
                
            }
    }

    useEffect(() => {
        if (bp_risk_list.length > 0) {
            setSelectedRisk(bp_risk_list[0]);
        }
    }, [bp_risk_list]);


    const getRiskDetails = (risk) => {

        setSelectedRisk(risk)

        fetchMappedControls(risk.id)

        setCurrentRisk(risks)

    }

    const riskLevelOption = [
        { value: 'High', label: 'High' },
        { value: 'Medium', label: 'Medium' },
        { value: 'Low', label: 'Low' },
    ];


    const columnsWithActions_Control = [
        ...control_column,
        {
            field: 'status',
            headerName: 'Tag Control',
            width: 200,
            sortable: true,
            renderCell: renderMapControlButton,
        },
    ];
    const columnsWithActions_UnMapControl = [
        ...control_column,
        {
            field: 'status',
            headerName: 'Tag Control',
            width: 200,
            sortable: true,
            renderCell: renderUnMapControlButton,
        },
    ];

    const getRowClassName = (params) => {
        const risk = params.row;
        const isMapped = isRiskIDMapped(risk.riskID, mappedRisk);
        return isMapped ? 'mapped-row' : '';
    };

    const columnsWithActions = [
        { field: 'id', headerName: '#', width: 60 },
        { field: 'RISK_ID', headerName: 'Risk ID', width: 120 },
        { 
            field: 'RISK_NAME', 
            headerName: 'Risk Name', 
            flex: 1,
            renderCell: (params) => {
                const risk = params.row;
                const isMapped = isRiskIDMapped(risk.riskID, mappedRisk);
                return (
                    <span style={{ 
                        fontWeight: isMapped ? 500 : 400,
                        color: isMapped ? 'rgba(0, 0, 0, 0.9)' : 'inherit'
                    }}>
                        {params.value}
                    </span>
                );
            }
        },
        {
            field: 'RISK_DESCRIPTION',
            headerName: 'Description',
            flex: 1.5
        },
        {
            field: 'status',
            headerName: 'Risk Rating',
            width: 140,
            align: 'center',
            headerAlign: 'center',
            renderHeader: () => (
                <mui.Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                    <SecurityIcon sx={{ fontSize: 16 }} />
                    <span>Risk Rating</span>
                </mui.Box>
            ),
            renderCell: renderAuditPrepButton,
        },
    ];
    

    const tabs_ra = [
       
        {
            value: '1',
            label: (<div>
                IT Risk Library
            </div>),
            content: (
                <div>
                    <mui.Typography variant="subtitle2" sx={{ marginBottom: '10px' }}>
                        Click the 'Plus' button below to make the selected risk as relevant to {selectedApp.APP_NAME}
                    </mui.Typography>

                    <mui.Box sx={{ marginTop: '20px' }}>
                        <Suspense fallback={<div>Loading...</div>}>
                            <DataTable

                                rows={it_rows}
                                columns={columns}
                                columnsWithActions={columnsWithActions}
                            />
                        </Suspense>
                    </mui.Box>
                </div>)
        },
        {
            value: '2',
            label: (<div>
                Business Process Risks Library
            </div>),
            content: (
                <div>
                    <mui.Typography variant="subtitle2" sx={{ marginBottom: '10px' }}>
                        Click the 'Plus' button below to make the selected risk as relevant to {selectedApp.APP_NAME}
                    </mui.Typography>

                    <mui.Box sx={{ marginTop: '20px' }}>
                        <Suspense fallback={<div>Loading...</div>}>
                            <DataTable
                                rows={rows}
                                columns={columns}
                                columnsWithActions={columnsWithActions}
                            />
                        </Suspense>
                    </mui.Box>
                </div>)
        },
        {
            value: '3',
            label: (<div>
                Operational Risk Library
            </div>),
            content: (
                <div>
                    <mui.Typography variant="subtitle2" sx={{ marginBottom: '10px' }}>
                        Click the 'Plus' button below to make the selected risk as relevant to {selectedApp.APP_NAME}
                    </mui.Typography>

                    <mui.Box sx={{ marginTop: '20px' }}>
                        <Suspense fallback={<div>Loading...</div>}>
                            <DataTable

                                rows={operational_rows}
                                columns={columns}
                                columnsWithActions={columnsWithActions}
                            />
                        </Suspense>
                    </mui.Box>
                </div>)
        },
        {
            value: '4',
            label: (<div>
                Entity Level Risk Library
            </div>),
            content: (
                <div>
                    <mui.Typography variant="subtitle2" sx={{ marginBottom: '10px' }}>
                        Click the 'Plus' button below to make the selected risk as relevant to {selectedApp.APP_NAME}
                    </mui.Typography>

                    <mui.Box sx={{ marginTop: '20px' }}>
                        <Suspense fallback={<div>Loading...</div>}>
                            <DataTable

                                rows={entity_rows}
                                columns={columns}
                                columnsWithActions={columnsWithActions}
                            />
                        </Suspense>
                    </mui.Box>
                </div>)
        },
    ]

    const tabs = [

        {
            value: '1',
            label: (<div>
                <InsightsIcon style={{ marginRight: '8px', color: '#1976d2' }} /> Application Overview
            </div>),
            content: (
                <div>

                    <mui.Paper sx={{ padding: '20px' }}>

                        <mui.Typography variant="h6" sx={{ marginBottom: '10px' }}>
                            <GridViewRoundedIcon style={{ color: 'grey' }} /> General Information
                        </mui.Typography>

                        <NormalTextField
                            label="Application Name"
                            name="APP_NAME"
                            value={selectedApp.APP_NAME}
                        />

                        <NormalTextField
                            label="Company Name"
                            name="COMPANY_NAME"
                            value={selectedApp.COMPANY_NAME}
                        />

                        <NormalTextField
                            label="Application Description"
                            name="APP_DESCRIPTION"
                            value={selectedApp.APP_DESCRIPTION}
                            isMultiLine={true}
                            rows="8"
                        />

                        <NormalTextField
                            label="Application Type"
                            name="APP_TYPE"
                            value={selectedApp.APP_TYPE}
                        />

                        <NormalTextField
                            label="Hosting"
                            name="HOSTED"
                            value={selectedApp.HOSTED}
                        />

                        <NormalTextField
                            label="Authentication"
                            name="AUTHENTICATION_TYPE"
                            value={selectedApp.AUTHENTICATION_TYPE}
                        />

                    </mui.Paper>

                    <mui.Paper sx={{ padding: '20px', marginTop: '20px' }}>

                        <mui.Typography variant="h6" sx={{ marginBottom: '10px' }}>
                            <CellTowerRoundedIcon style={{ color: 'grey' }} /> Infrastructure
                        </mui.Typography>

                        <NormalTextField
                            label="Operating System"
                            name="OS"
                            value={operatingSystem ? operatingSystem : ''}
                        />

                        <NormalTextField
                            label="Operating System Version"
                            name="OS_VERSION"
                            value={selectedApp.OS_VERSION ? selectedApp.OS_VERSION : ''}
                        />

                        <NormalTextField
                            label="Database"
                            name="DATABASE"
                            value={database ? database : ''}
                        />

                        <NormalTextField
                            label="Database Version"
                            name="DB_VERSION"
                            value={selectedApp.DB_VERSION ? selectedApp.DB_VERSION : ''}
                        />

                        <NormalTextField
                            label="Network"
                            name="NETWORK"
                            value={network ? network : ''}
                        />

                        <NormalTextField
                            label="Network Version"
                            name="NETWORK_VERSION"
                            value={selectedApp.NETWORK_VERSION ? selectedApp.NETWORK_VERSION : ''}
                        />

                    </mui.Paper>


                    <mui.Paper sx={{ padding: '20px', marginTop: '20px' }}>
                        <mui.Typography variant="h6" sx={{ marginBottom: '10px' }}>
                            <LibraryBooksRoundedIcon style={{ color: 'grey' }} /> Accounts
                        </mui.Typography>
                    </mui.Paper>

                    <mui.Paper sx={{ padding: '20px', marginTop: '20px' }}>
                        <mui.Typography variant="h6" sx={{ marginBottom: '10px' }}>
                            <AccountTreeRoundedIcon style={{ color: 'grey' }} /> Business Process
                        </mui.Typography>
                    </mui.Paper>

                </div>)
        },
        {
            value: '2',
            label: (<div>
                <BookmarkAddIcon style={{ marginRight: '8px', color: '#1976d2' }} /> Risk Identification and Control Mapping
            </div>),
            content: (
                <div>
                    <mui.Paper 
                        elevation={0}
                        sx={{ 
                            padding: '24px', 
                            borderRadius: '8px',
                            boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                            border: '1px solid rgba(0,0,0,0.09)',
                            marginBottom: '20px'
                        }}
                    >
                        {/* Simplified header */}
                        <mui.Stack direction="row" alignItems="center" spacing={2} mb={3}>
                            <BookmarkAddIcon color="primary" />
                            <mui.Typography variant="h6" color="primary.main">
                                Identify relevant risks for {selectedApp.APP_NAME}
                            </mui.Typography>
                        </mui.Stack>
                        
                        {/* Risk mapping progress summary - Kept but styled more minimally */}
                        <mui.Box sx={{ mb: 4 }}>
                            <mui.Grid container spacing={2}>
                                <mui.Grid item xs={12} sm={6} md={3}>
                                    <mui.Paper
                                        elevation={0}
                                        sx={{
                                            p: 2,
                                            borderRadius: '8px',
                                            border: '1px solid rgba(25, 118, 210, 0.12)',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            bgcolor: 'rgba(25, 118, 210, 0.04)'
                                        }}
                                    >
                                        <mui.Typography variant="subtitle2" color="text.secondary" align="center">
                                            IT Risks
                                        </mui.Typography>
                                        <mui.Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                                            <mui.Typography variant="h5" fontWeight="bold" color="primary.main">
                                                {it_mapping.length}
                                            </mui.Typography>
                                            <mui.Typography variant="body2" color="text.secondary" sx={{ ml: 1 }}>
                                                / {it_rows.length}
                                            </mui.Typography>
                                        </mui.Box>
                                        <mui.LinearProgress 
                                            variant="determinate" 
                                            value={it_rows.length > 0 ? (it_mapping.length / it_rows.length) * 100 : 0} 
                                            sx={{ width: '100%', mt: 1, height: 6, borderRadius: 3 }}
                                        />
                                    </mui.Paper>
                                </mui.Grid>
                                
                                <mui.Grid item xs={12} sm={6} md={3}>
                                    <mui.Paper
                                        elevation={0}
                                        sx={{
                                            p: 2,
                                            borderRadius: '8px',
                                            border: '1px solid rgba(25, 118, 210, 0.12)',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            bgcolor: 'rgba(25, 118, 210, 0.04)'
                                        }}
                                    >
                                        <mui.Typography variant="subtitle2" color="text.secondary" align="center">
                                            Business Process
                                        </mui.Typography>
                                        <mui.Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                                            <mui.Typography variant="h5" fontWeight="bold" color="primary.main">
                                                {bp_mapping.length}
                                            </mui.Typography>
                                            <mui.Typography variant="body2" color="text.secondary" sx={{ ml: 1 }}>
                                                / {rows.length}
                                            </mui.Typography>
                                        </mui.Box>
                                        <mui.LinearProgress 
                                            variant="determinate" 
                                            value={rows.length > 0 ? (bp_mapping.length / rows.length) * 100 : 0} 
                                            sx={{ width: '100%', mt: 1, height: 6, borderRadius: 3 }}
                                        />
                                    </mui.Paper>
                                </mui.Grid>
                                
                                <mui.Grid item xs={12} sm={6} md={3}>
                                    <mui.Paper
                                        elevation={0}
                                        sx={{
                                            p: 2,
                                            borderRadius: '8px',
                                            border: '1px solid rgba(25, 118, 210, 0.12)',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            bgcolor: 'rgba(25, 118, 210, 0.04)'
                                        }}
                                    >
                                        <mui.Typography variant="subtitle2" color="text.secondary" align="center">
                                            Operational
                                        </mui.Typography>
                                        <mui.Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                                            <mui.Typography variant="h5" fontWeight="bold" color="primary.main">
                                                {ops_mapping.length}
                                            </mui.Typography>
                                            <mui.Typography variant="body2" color="text.secondary" sx={{ ml: 1 }}>
                                                / {operational_rows.length}
                                            </mui.Typography>
                                        </mui.Box>
                                        <mui.LinearProgress 
                                            variant="determinate" 
                                            value={operational_rows.length > 0 ? (ops_mapping.length / operational_rows.length) * 100 : 0} 
                                            sx={{ width: '100%', mt: 1, height: 6, borderRadius: 3 }}
                                        />
                                    </mui.Paper>
                                </mui.Grid>
                                
                                <mui.Grid item xs={12} sm={6} md={3}>
                                    <mui.Paper
                                        elevation={0}
                                        sx={{
                                            p: 2,
                                            borderRadius: '8px',
                                            border: '1px solid rgba(25, 118, 210, 0.12)',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            bgcolor: 'rgba(25, 118, 210, 0.04)'
                                        }}
                                    >
                                        <mui.Typography variant="subtitle2" color="text.secondary" align="center">
                                            Entity Level
                                        </mui.Typography>
                                        <mui.Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                                            <mui.Typography variant="h5" fontWeight="bold" color="primary.main">
                                                {entity_mapping.length}
                                            </mui.Typography>
                                            <mui.Typography variant="body2" color="text.secondary" sx={{ ml: 1 }}>
                                                / {entity_rows.length}
                                            </mui.Typography>
                                        </mui.Box>
                                        <mui.LinearProgress 
                                            variant="determinate" 
                                            value={entity_rows.length > 0 ? (entity_mapping.length / entity_rows.length) * 100 : 0} 
                                            sx={{ width: '100%', mt: 1, height: 6, borderRadius: 3 }}
                                        />
                                    </mui.Paper>
                                </mui.Grid>
                            </mui.Grid>
                        </mui.Box>

                        <DynamicTabs 
                            tabs={tabs_ra.map(tab => ({
                                ...tab,
                                label: (
                                    <mui.Stack direction="row" alignItems="center" spacing={1}>
                                        {tab.value === '1' && <mui.Icon fontSize="small">computer</mui.Icon>}
                                        {tab.value === '2' && <mui.Icon fontSize="small">account_tree</mui.Icon>}
                                        {tab.value === '3' && <mui.Icon fontSize="small">settings</mui.Icon>}
                                        {tab.value === '4' && <mui.Icon fontSize="small">business</mui.Icon>}
                                        <span>{tab.label}</span>
                                    </mui.Stack>
                                ),
                                content: (
                                    <div>
                                        <mui.Box sx={{ 
                                            marginTop: '16px', 
                                            boxShadow: '0 1px 4px rgba(0,0,0,0.05)',
                                            borderRadius: '8px',
                                            overflow: 'hidden'
                                        }}>
                                            <Suspense fallback={
                                                <mui.Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
                                                    <mui.CircularProgress size={40} />
                                                </mui.Box>
                                            }>
                                                {tab.value === '1' && (
                                                    <DataTable 
                                                        rows={it_rows} 
                                                        columns={columns} 
                                                        columnsWithActions={columnsWithActions}
                                                        getRowClassName={getRowClassName}
                                                        sx={{
                                                            '& .mapped-row': {
                                                                backgroundColor: 'rgba(25, 118, 210, 0.04)',
                                                                '&:hover': {
                                                                    backgroundColor: 'rgba(25, 118, 210, 0.08) !important',
                                                                },
                                                                '& .MuiDataGrid-cell': {
                                                                    borderBottomColor: 'rgba(25, 118, 210, 0.1)',
                                                                }
                                                            }
                                                        }}
                                                    />
                                                )}
                                                {tab.value === '2' && (
                                                    <DataTable 
                                                        rows={rows} 
                                                        columns={columns} 
                                                        columnsWithActions={columnsWithActions}
                                                        getRowClassName={getRowClassName}
                                                        sx={{
                                                            '& .mapped-row': {
                                                                backgroundColor: 'rgba(25, 118, 210, 0.04)',
                                                                '&:hover': {
                                                                    backgroundColor: 'rgba(25, 118, 210, 0.08) !important',
                                                                },
                                                                '& .MuiDataGrid-cell': {
                                                                    borderBottomColor: 'rgba(25, 118, 210, 0.1)',
                                                                }
                                                            }
                                                        }}
                                                    />
                                                )}
                                                {tab.value === '3' && (
                                                    <DataTable 
                                                        rows={operational_rows} 
                                                        columns={columns} 
                                                        columnsWithActions={columnsWithActions}
                                                        getRowClassName={getRowClassName}
                                                        sx={{
                                                            '& .mapped-row': {
                                                                backgroundColor: 'rgba(25, 118, 210, 0.04)',
                                                                '&:hover': {
                                                                    backgroundColor: 'rgba(25, 118, 210, 0.08) !important',
                                                                },
                                                                '& .MuiDataGrid-cell': {
                                                                    borderBottomColor: 'rgba(25, 118, 210, 0.1)',
                                                                }
                                                            }
                                                        }}
                                                    />
                                                )}
                                                {tab.value === '4' && (
                                                    <DataTable 
                                                        rows={entity_rows} 
                                                        columns={columns} 
                                                        columnsWithActions={columnsWithActions}
                                                        getRowClassName={getRowClassName}
                                                        sx={{
                                                            '& .mapped-row': {
                                                                backgroundColor: 'rgba(25, 118, 210, 0.04)',
                                                                '&:hover': {
                                                                    backgroundColor: 'rgba(25, 118, 210, 0.08) !important',
                                                                },
                                                                '& .MuiDataGrid-cell': {
                                                                    borderBottomColor: 'rgba(25, 118, 210, 0.1)',
                                                                }
                                                            }
                                                        }}
                                                    />
                                                )}
                                            </Suspense>
                                        </mui.Box>

                                        {/* Simplified legend */}
                                        <mui.Box sx={{ 
                                            display: 'flex', 
                                            justifyContent: 'flex-end',
                                            alignItems: 'center',
                                            mt: 2,
                                            gap: 3
                                        }}>
                                            <mui.Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <mui.Box 
                                                    sx={{ 
                                                        width: 12, 
                                                        height: 12, 
                                                        bgcolor: 'rgba(25, 118, 210, 0.1)',
                                                        mr: 1,
                                                        borderRadius: 0.5
                                                    }} 
                                                />
                                                <mui.Typography variant="caption" color="text.secondary">Mapped</mui.Typography>
                                            </mui.Box>
                                        </mui.Box>
                                    </div>
                                )
                            }))}
                        />
                    </mui.Paper>
                </div>
            )
        },
       
      
    ]

    const customMainContent = (
        <div>
            <ResponsiveContainer>
                <mui.Box sx={{ 
                    padding: { xs: '16px', sm: '24px' },
                    maxWidth: '1600px',
                    margin: '0 auto'
                }}>
                    <mui.Breadcrumbs 
                        aria-label="breadcrumb"
                        sx={{
                            '& .MuiLink-root': {
                                display: 'flex',
                                alignItems: 'center',
                                color: 'text.secondary',
                                fontSize: '0.875rem',
                                transition: 'color 0.2s ease',
                                '&:hover': {
                                    color: 'primary.main'
                                }
                            }
                        }}
                    >
                        <mui.Link underline="hover" color="inherit" href="/dashboard">
                            <i className="material-icons" style={{ fontSize: '16px', marginRight: '4px' }}>home</i>
                        </mui.Link>
                        <mui.Link underline="hover" color="inherit" href="/dashboard">
                            My Dashboard
                        </mui.Link>
                        <mui.Typography color="text.primary">{selectedCompany.COMPANY_NAME}</mui.Typography>
                        <mui.Typography color="text.primary">Risk and Control Mapping</mui.Typography>
                        <mui.Typography color="text.primary" fontWeight="medium">{selectedApp.APP_NAME}</mui.Typography>
                    </mui.Breadcrumbs>

                    <mui.Box sx={{ 
                        display: 'flex', 
                        alignItems: 'flex-start', 
                        mb: 4, 
                        mt: 3,
                        flexDirection: { xs: 'column', sm: 'row' },
                        gap: { xs: 2, sm: 0 }
                    }}>
                        <ReviewsRoundedIcon sx={{ 
                            fontSize: 28, 
                            color: 'primary.main', 
                            mr: { xs: 0, sm: 2.5 },
                            opacity: 0.9
                        }} />
                        <mui.Box sx={{ flex: 1 }}>
                            <mui.Typography 
                                variant="h4" 
                                component="h1" 
                                sx={{ 
                                    fontWeight: 600, 
                                    color: 'text.primary', 
                                    mb: 1,
                                    fontSize: { xs: '1.5rem', sm: '2rem' }
                                }}
                            >
                                Risk Mapping
                            </mui.Typography>
                            <mui.Typography 
                                variant="body2" 
                                sx={{ 
                                    color: 'text.secondary',
                                    mb: 2
                                }}
                            >
                                Map risk to relevant control to address the risk
                            </mui.Typography>
                        </mui.Box>
                    </mui.Box>

                    <mui.Box sx={{ 
                        backgroundColor: '#ffffff', 
                        borderRadius: 2,
                        minHeight: '80vh',
                        border: '1px solid',
                        borderColor: 'rgba(0,0,0,0.06)',
                        boxShadow: '0 1px 3px 0 rgba(0,0,0,0.1)'
                    }}>
                        <mui.Paper 
                            elevation={0}
                            sx={{ 
                                p: { xs: 2, sm: 3 },
                                height: '100%',
                                backgroundColor: 'transparent'
                            }}
                        >
                            <mui.Grid
                                container spacing={3}
                                direction="row"
                                justifyContent="flex-start"
                                alignItems="center"
                            >
                                <mui.Grid item
                                    xs={12}
                                    sx={{ transition: 'margin-left 0.3s ease', marginLeft: sidebarVisible ? 0 : 3 }} >
                                    <DynamicTabs tabs={tabs} />
                                </mui.Grid>
                            </mui.Grid>
                            
                            {/* Dialog loading indicator */}
                            {dialogLoading && (
                                <mui.Backdrop
                                    sx={{
                                        color: 'primary.main',
                                        zIndex: (theme) => theme.zIndex.drawer + 1,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                    }}
                                    open={dialogLoading}
                                >
                                    <mui.CircularProgress color="inherit" size={40} thickness={4} />
                                    <mui.Typography 
                                        variant="body2" 
                                        sx={{ 
                                            mt: 2, 
                                            fontWeight: 500,
                                            color: 'primary.main',
                                            backgroundColor: 'rgba(255, 255, 255, 0.8)',
                                            px: 2,
                                            py: 0.5,
                                            borderRadius: 1,
                                        }}
                                    >
                                        Loading risk details...
                                    </mui.Typography>
                                </mui.Backdrop>
                            )}
                            
                            {/* Add the ConsolidatedRiskDialog component */}
                            <ConsolidatedRiskDialog
                                open={openConsolidatedDialog}
                                onClose={handleCloseConsolidatedDialog}
                                risk={selectedConsolidatedRisk}
                                appId={id}
                                companyId={company_id}
                                controls={controls}
                                onSaveSuccess={handleConsolidatedDialogSave}
                            />
                        </mui.Paper>
                    </mui.Box>
                </mui.Box>
            </ResponsiveContainer>
        </div>
    );
    
    return (
        <Suspense fallback={
            <mui.Box 
                sx={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    height: '100vh',
                    backgroundColor: '#f8fafc'
                }}
            >
                <mui.Box sx={{ textAlign: 'center' }}>
                    <mui.CircularProgress 
                        size={40} 
                        thickness={4}
                        sx={{
                            color: 'primary.main',
                            animation: 'pulse 1.5s ease-in-out infinite',
                        }}
                    />
                    <mui.Typography 
                        variant="body1" 
                        sx={{ 
                            mt: 2, 
                            color: 'text.secondary',
                            fontWeight: 500
                        }}
                    >
                        Loading Risk Mapping...
                    </mui.Typography>
                </mui.Box>
            </mui.Box>
        }>
            <div>
                <IASideBar mainContent={customMainContent} />
            </div>
        </Suspense>
    );
}

export default RiskMapping;